import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import RootStore from "SandboxViewerComponent/src/stores/RootStore";
import SearchBar from "components/searchReact/SearchBarReact";
import { observer } from "mobx-react";
import { styled } from "@mui/material";
import {
  niedersachsenEnvUrl,
  nikoUrl,
  nlwknUrl,
  lbegUrl,
  locationSearchUrl,
  locationSearchProxyUrl,
} from "configs/config";
const Spacer = styled("div")({
  flexGrow: 1,
});

const logoStyle = {
  height: 38,
  marginRight: 12,
  cursor: "pointer",
};

const logoNLWKNStyle = {
  height: 32,
  marginRight: 12,
  cursor: "pointer",
};

const logoNIKOStyle = {
  height: 38,
  cursor: "pointer",
};

function SearchAppBar() {
  const { height, width, mobile } = RootStore.uiStore.BBStore;
  return (
    <div style={{ flexGrow: 0 }}>
      <AppBar position="static">
        <Toolbar
          style={{
            minHeight: 54,
            background: "white",
            paddingLeft: 20,
          }}
        >
          {width > 599 && (
            <Typography
              sx={{
                // flexGrow: 1,
                fontSize: "22px",
                fontWeight: 700,
                color: "rgb(229, 0, 66)", //"#E0042",
                fontFamily: "Frutiger W01",
                display: {
                  xs: "none",
                  sm: "block",
                },
              }}
              variant="h6"
              noWrap
            >
              {"NIKLIS – Niedersächsisches Klimainformationssystem"}
            </Typography>
          )}
          {width > 599 && <Spacer />}
          {width > 500 && (
            <SearchBar
              map={RootStore.mapStore.map}
              mapView={RootStore.mapStore.mapView}
              locationSearchUrl={locationSearchUrl}
              locationSearchProxyUrl={locationSearchProxyUrl}
            ></SearchBar>
          )}
          <Spacer />
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src="Niedersachsen_logo.svg"
              style={logoStyle}
              alt="Logo des Landes Niedersachsen"
              onClick={() => {
                window.open(niedersachsenEnvUrl, "blank");
              }}
            />
            <img
              src="NIKO.png"
              style={logoNIKOStyle}
              alt="Logo des niedersächsischen Kompetenzzentrums Klimawandel"
              onClick={() => {
                window.open(nikoUrl, "blank");
              }}
            />
            <img
              src="nlwkn_logo.png"
              style={logoNLWKNStyle}
              alt="Logo des niedersächsischen Landesbetriebs für Wasserwirtschaft, Küsten- und Naturschutz"
              onClick={() => {
                window.open(nlwknUrl, "blank");
              }}
            />
            <img
              src="LBEG_logo.svg"
              style={logoStyle}
              alt="Logo des Landesamts für Bergbau, Energie und Geologie"
              onClick={() => {
                window.open(lbegUrl, "blank");
              }}
            />
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}
export default observer(SearchAppBar);
